import { CSSProperties, FC, ReactNode } from 'react'
import styled from 'styled-components'

import { frostedGlass } from 'Utils/styles/colors'
import { ThinDarkGreenText } from 'Utils/styles/text'
import { spacingLG, spacingSM } from 'Utils/styles/spacing'

const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${spacingSM} ${spacingLG};
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  width: 100%;
  min-height: 48px;
  background-color: ${frostedGlass};
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: ${spacingSM};
`

type AlertBannerProps = {
  alert: string
  children?: ReactNode
  style?: CSSProperties
  iconSrc?: string
  className?: string
}

export const AlertBanner: FC<AlertBannerProps> = ({
  alert,
  children,
  style,
  iconSrc,
  className
}) => {
  return (
    <BannerContainer className={className} style={style}>
      {iconSrc && (
        <IconContainer>
          <img src={iconSrc} alt="alert-icon" />
        </IconContainer>
      )}
      <ThinDarkGreenText>{alert}</ThinDarkGreenText>
      {children}
    </BannerContainer>
  )
}
